<h2 mat-dialog-title>Підтвердження</h2>
<mat-dialog-content>
  <p>{{ data.text }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Ні</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">Так</button>
</mat-dialog-actions>
